/* tslint:disable */
/* eslint-disable */
/**
 * FOPkasa.Web
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosResponse, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { CashRegisterResponse } from '../models';
/**
 * CashRegisterApi - axios parameter creator
 * @export
 */
export const CashRegisterApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [pointOfSaleId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCashRegisterGet: async (pointOfSaleId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/CashRegister`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (pointOfSaleId !== undefined) {
                localVarQueryParameter['pointOfSaleId'] = pointOfSaleId;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CashRegisterApi - functional programming interface
 * @export
 */
export const CashRegisterApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [pointOfSaleId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCashRegisterGet(pointOfSaleId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<Array<CashRegisterResponse>>>> {
            const localVarAxiosArgs = await CashRegisterApiAxiosParamCreator(configuration).apiCashRegisterGet(pointOfSaleId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CashRegisterApi - factory interface
 * @export
 */
export const CashRegisterApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {number} [pointOfSaleId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCashRegisterGet(pointOfSaleId?: number, options?: AxiosRequestConfig): Promise<AxiosResponse<Array<CashRegisterResponse>>> {
            return CashRegisterApiFp(configuration).apiCashRegisterGet(pointOfSaleId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CashRegisterApi - object-oriented interface
 * @export
 * @class CashRegisterApi
 * @extends {BaseAPI}
 */
export class CashRegisterApi extends BaseAPI {
    /**
     * 
     * @param {number} [pointOfSaleId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CashRegisterApi
     */
    public async apiCashRegisterGet(pointOfSaleId?: number, options?: AxiosRequestConfig) : Promise<AxiosResponse<Array<CashRegisterResponse>>> {
        return CashRegisterApiFp(this.configuration).apiCashRegisterGet(pointOfSaleId, options).then((request) => request(this.axios, this.basePath));
    }
}
